module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/alessandria.8e7e072a1219eff1b1b71f2d80597afb.jpg";